import "@/App.css";
import { BrowserRouter, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider, useStore } from "@/context/StoreContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AddedNotice, BagDrawer } from "@/components/BagDrawer";
import { Emblem } from "@/components/Logo";
import { Cta } from "@/components/Cta";
import Home from "@/pages/Home";
import ProductPage from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import { Policy, Shop } from "@/pages/Shop";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import Products from "@/admin/Products";
import Orders from "@/admin/Orders";
import Payments from "@/admin/Payments";
import Design from "@/admin/Design";
import Settings from "@/admin/Settings";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
};

const StoreLayout = () => {
  const { site, failed } = useStore();
  if (!site)
    return (
      <div className="min-h-screen grid place-items-center bg-pearl" data-testid="store-loading">
        <div className="text-center">
          <Emblem className="w-16 h-14 mx-auto animate-pulse text-plum" gem="#D2B27A" />
          <p className="font-display text-[22px] tracking-[0.3em] mt-4">{failed ? "We'll be right back" : "RATNAHARA"}</p>
        </div>
      </div>
    );
  return (
    <>
      <ScrollTop />
      <Header />
      <Outlet />
      <Footer />
      <BagDrawer />
      <AddedNotice />
    </>
  );
};

const NotFound = () => (
  <main className="container-rh py-32 text-center">
    <p className="font-display text-[56px]">This page wandered off.</p>
    <div className="mt-8"><Cta to="/" label="Back to RATNAHARA" /></div>
  </main>
);

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <Routes>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/wishlist" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:number" element={<Payment />} />
              <Route path="/policy/:key" element={<Policy />} />
              <Route path="/contact" element={<Policy contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="products" element={<Products />} />
              <Route path="orders" element={<Orders />} />
              <Route path="payments" element={<Payments />} />
              <Route path="design" element={<Design />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}
